import { render, staticRenderFns } from "./CardStatCmi.vue?vue&type=template&id=1ca55870&scoped=true&"
import script from "./CardStatCmi.vue?vue&type=script&lang=js&"
export * from "./CardStatCmi.vue?vue&type=script&lang=js&"
import style0 from "./CardStatCmi.vue?vue&type=style&index=0&id=1ca55870&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca55870",
  null
  
)

export default component.exports